import Api from '../http.service';
/**
 * @param {Object} payload
 * @param {string} payload.profileId
 * @param {string} payload.pageNumber
 * @param {string} payload.itemPerPage
 * @param {Object} payload.data
 * @param {Object} payload.data.sort
 * @param {Object} payload.data.filter
 */

export const getAllByProfileId = (payload) =>
  Api.GET({
    url: `business_license/profile?profileId=${payload.profileId}&page=${
      payload.pageNumber - 1
    }&size=${payload.itemPerPage}`,
  });

/**
 * @param {Object} payload
 * @param {string} payload.pageNumber
 * @param {number} payload.itemPerPage
 * @param {Object} payload.data
 * @param {String} payload.data.filter
 */

export const getAll = ({ pageNumber, itemPerPage, data }) =>
  Api.GET({
    url: `/business_license/all?size=${itemPerPage}&page=${
      pageNumber - 1
    }&where=${data.filter}`,
  });

/**
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {number} payload.data.profileId
 * @param {string} payload.data.licenseId
 * @param {number} payload.data.licenseNo
 * @param {string} payload.data.reference
 * @param {string} payload.data.licenseFile
 */

export const insert = (payload) =>
  Api.POST({ url: '/business_license/profile', data: payload.data });

/**
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {number} payload.data.profileId
 * @param {string} payload.data.license_id
 * @param {number} payload.data.licenseNo
 * @param {string} payload.data.reference
 * @param {string} payload.data.licenseFile
 */

export const update = (payload) =>
  Api.PUT({ url: '/business_license/profile', data: payload.data });

/**
 * @param {Object} payload
 * @param {String} payload._id
 */

export const deleteLicense = (payload) =>
  Api.DELETE({ url: 'business_license', data: payload });
